import { Order } from '#/api/orders';

import * as OrderFn from '#/features/perpetuals/trade-overview/order-functions';

import { OrderNotificationEntry } from './types';

export function getOrderNotificationType(
  order: Order,
): OrderNotificationEntry['kind'] | null {
  if (OrderFn.isMarketOrder(order) && OrderFn.hadSomeFill(order)) {
    return 'filled-market-order';
  }
  if (OrderFn.isMarketOrder(order) && OrderFn.isCancelledOrder(order)) {
    return 'cancelled-market-order';
  }
  if (OrderFn.isLimitOrder(order) && OrderFn.isCancelledOrder(order)) {
    return 'cancelled-limit-order';
  }

  return null;
}
